import { loadStripe } from "@stripe/stripe-js"
import { Elements } from "@stripe/react-stripe-js"
import PropTypes from "prop-types"

export default function StripeJsContainer({ children, email, selectedPrice }) {
  const isIftttEmail = email && email.endsWith("@ifttt.com")
  const enableDeveloperTools = (window.App.env === "development" || window.location.hostname === "web-rehearsal.ifttt.com") && isIftttEmail
  const stripePromise = loadStripe(window.App.stripePublishableKey, {
    developerTools: {
      assistant: {
        enabled: enableDeveloperTools,
      }
    }
  })

  let paymentMethodTypes = ["card"]
  if (window.App.paymentStrategy === "admin_test" && isIftttEmail) {
    paymentMethodTypes = ["card", "us_bank_account"]
  } else if (window.App.paymentStrategy === "stripe_dashboard") {
    paymentMethodTypes = []
  }

  const elementOptions = {
    mode: "subscription",
    amount: selectedPrice,
    currency: "usd",
    paymentMethodTypes: paymentMethodTypes,
    appearance: {
      // https://docs.stripe.com/elements/appearance-api?api-integration=paymentintents
      theme: "flat",
      labels: "floating",
      inputs: "spaced",
      variables: {
        // https://docs.stripe.com/elements/appearance-api?api-integration=paymentintents#variables
        fontFamily: '"Avenir Next", "Avenir Next W01", "Avenir", helvetica, arial, sans-serif',
        fontSizeBase: "16px",
        fontLineHeight: "1.1",
        fontWeightBold: "700",
        borderRadius: "8px",
        colorPrimary: "#222222",
        colorPrimaryText: "#222222",
        colorText: "#222222",
        colorTextSecondary: "#77787D",
        colorDanger: "#fa755a",
        colorBackground: "#ffffff",
        colorIconTabSelected: "#222222",
        iconColor: "#222222",
        tabIconColor: "#22222266",
        tabIconSelectedColor: "#222222",
        focusBoxShadow: "none",
        focusOutline: "none",
      },
      rules: {
        // https://docs.stripe.com/elements/appearance-api?api-integration=paymentintents#supported-css-properties
        ".Tab": {
          padding: "8px",
          border: "4px solid transparent",
          borderRadius: "8px",
          backgroundColor: "#2222220d",
          color: "#22222266",
        },
        ".Tab--selected": {
          backgroundColor: "#fff",
          border: "4px solid #2222221a",
          color: "#222222",
          boxShadow: "none",
        },
        ".Tab:focus": {
          border: "4px solid #2222221a",
          boxShadow: "none",
          outline: "none",
        },
        ".Tab--selected:focus": {
          border: "4px solid #2222221a",
          boxShadow: "none",
          outline: "none",
        },
        ".Tab:focus-visible": {
          border: "4px solid #2222221a",
          boxShadow: "none",
          outline: "none",
        },
        ".Tab--selected:focus-visible": {
          border: "4px solid #2222221a",
          boxShadow: "none",
          outline: "none",
        },
        ".TabLabel": {
          fontSize: "1.4em", // higher to be near to 1.25em from labels resting and inputs
          fontWeight: "700",
        },
        ".Input": {
          fontSize: "1.25em",
          fontWeight: "700", // Same from labels resting
          border: "4px solid #2222221a",
          borderRadius: "8px",
          backgroundColor: "#ffffff",
          padding: "8px",
        },
        ".Input:focus": {
          border: "4px solid #222222",
          boxShadow: "none",
        },
        ".Label--resting": {
          fontSize: "1.25em",
          fontWeight: "700",
          color: "#22222299",
        },
        ".Label--floating": {
          fontSize: "12px",
          fontWeight: "700",
        },
        ".PickerItem": {
          padding: "8px",
        }
      },
    },
  }

  // Usage of 'stripe' and 'elements' must be in a child component of <Elements>
  return <Elements stripe={stripePromise} options={elementOptions}>{children}</Elements>
}

StripeJsContainer.propTypes = {
  children: PropTypes.node.isRequired,
  email: PropTypes.string,
  selectedPrice: PropTypes.number,
}
